<template>
  <v-alert
    :variant="'outlined'"
    :density="'compact'"
    :color="timestampStatus"
    class="mx-2 mb-0 mt-2 text-center"
    text-center
  >
    <v-icon left :color="iconColor" class="mr-2">mdi-clock-outline</v-icon>
    <div v-if="latestTimestamp">
      Latest data:
      {{ latestTimestamp.toLocaleDateString() }}
      {{
        latestTimestamp
          .toLocaleTimeString("en-NZ", { hour12: false })
          .slice(0, -3)
      }}
    </div>
    <div v-else>No recent data available.</div>
  </v-alert>
</template>

<script>
export default {
  props: {
    latestTimestamp: {
      type: Date,
      required: false,
      default: null,
    },
  },
  computed: {
    timestampStatus() {
      if (!this.latestTimestamp) {
        return "error"; // Red for missing data
      }
      const hoursSinceLastTimestamp =
        (new Date() - this.latestTimestamp) / 1000 / 3600;
      if (hoursSinceLastTimestamp > 36) {
        return "error"; // Red for outdated data
      } else if (hoursSinceLastTimestamp > 24) {
        return "warning"; // Yellow for semi-outdated data
      } else {
        return "success"; // Green for recent data
      }
    },
    iconColor() {
      if (this.timestampStatus === "error") {
        return "error";
      } else if (this.timestampStatus === "warning") {
        return "warning";
      } else {
        return "success";
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .v-alert {
    font-size: 12px;
  }
}
</style>
